/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type SbSharedTopTileController_viewer$ref: FragmentReference;
export type SbSharedTopTileController_viewer = {|
  +disablePriceTiles: ?boolean,
  +$refType: SbSharedTopTileController_viewer$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "SbSharedTopTileController_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": "disablePriceTiles",
      "name": "isEnabled",
      "args": [
        {
          "kind": "Literal",
          "name": "key",
          "value": "disablePriceTiles",
          "type": "String!"
        }
      ],
      "storageKey": "isEnabled(key:\"disablePriceTiles\")"
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '108b32f155f76b5b36eb14a204effae2';
module.exports = node;
